import { get, post } from '@/tools/http';

const service = 'examination';

export default {
    namespaced: true,
    state: {
        sessionType: 'test',
        singleSession: true,
        redirectUrl: null,
    },
    getters: {
        getSessionType: state => state.sessionType,
        getSingleSession: state => state.singleSession,
        getRedirectUrl: state => state.redirectUrl,
    },
    mutations: {
        setSessionType: (state, data) => state.sessionType = data,
        setSingleSession: (state, data) => state.singleSession = data,
        setRedirectUrl: (state, data) => state.redirectUrl = data,
    },
    actions: {
        startSession: async (ctx, { activityId, returnUrl }) => {
            const type = ctx.getters.getSessionType;
            const singleSession = ctx.getters.getSingleSession;

            const url = `sessions/${type}/${activityId}/start?single_result=${singleSession}`;
            const data = returnUrl ? { returnUrl } : {};

            const response = await post(service, url, data, true);
            if (!response) {
                return null;
            }

            const redirectUrl = response.redirectUrl || null;
            
            ctx.commit('setRedirectUrl', redirectUrl);
            return redirectUrl;
        },
    },
};